import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout'
import AboutSection1 from './AboutSection1'
import AboutSection5 from './AboutSection5'
import AboutSection4 from './AboutSection4'
import AboutSection6 from './AboutSection6'
import AboutWhyUS from './AboutWhyUS'
import Aboutwhyus1 from './Aboutwhyus1'
import TeamAPI from './TeamAPI'
import AboutWhyUS2 from './AboutWhyUS2'
// import FooterCalendar from '../../Layout/FooterCalendar'
import FooterNew from '../../Layout/FooterNew'
import axios from 'axios'
import SEO from '../../SEO'


const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";
function About() {
   const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'about' });

        if (response.data.status === 'true') {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error('SEO fetch error:', error);
      }
    };

    fetchSeo();
  }, []);
  return (
    <>
    <SEO
  title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
  description={seoData.description || "ShopIndia About page description..."}
  keywords={seoData.keywords || "ShopIndia, about, company, team"}
  canonical={seoData.canonical || "https://www.shopindia.com/about"}
/>

    <div>
      <Layout/>
      
      {/* <AboutSection1/> */}
      <AboutWhyUS2/>
      {/* <AboutWhyUS/> */}
      {/* <Aboutwhyus1/> */}
      {/* <AboutSection6/>  real one*/}
      <TeamAPI/>
      {/* <AboutSection4/> */}
      {/* <AboutSection5/> */}
      {/* <FooterCalendar/> */}
   <FooterNew/>
    </div>
    </>
  )
}

export default About
